import React from 'react';
import { Toast } from 'shared-components/BaseToast/Toast';
import PageContainer from 'shared-components/PageContainer/PageContainer';
import ProductForm from '../ProductForm/ProductForm';

const CreateProduct = () => {
  return (
    <PageContainer>
      <ProductForm title="Create a Product" />
      <Toast />
    </PageContainer>
  );
};

export default CreateProduct;
